import React from "react";
import { useTranslation } from "react-i18next";

import { PropertyType } from "../../../backend/types/utils";
import { PropertyInputTypeUnion, PropertyTypeIntersection } from "../../../store/property/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { KeyUndefinedError, RichTextFieldInternal, TextFieldInternal } from "./InputField";

type PropertyFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

type Predefined =
  | 'type'
  | 'properties'

export type PropertyInputTypeKey = keyof Omit<PropertyInputTypeUnion, Predefined>;

type PropertyFieldProps = SubformProps<PropertyTypeIntersection> & Partial<PropertyFieldDescriptor> & {
  id: PropertyInputTypeKey;
  noLabels?: boolean;
}

export const PropertyField = (props: PropertyFieldProps) : JSX.Element | null => {
  // Subform Props

  const { values } = props;

  // Generated Props

  const id = props.id as PropertyInputTypeKey;

  // Hooks

  const { t } = useTranslation();

  // Building Component

  switch (id) {
    case "key":
      return (
        <TextFieldInternal
          placeholder={t("Title")}
          { ...props }
        />
      );
    case "value":
      switch (values.type) {
        case PropertyType.RICH_TEXT:
          return (
            <RichTextFieldInternal
              { ...props }
            />
          );
        case PropertyType.MEDIA:
          return (
            <TextFieldInternal
              { ...props }
            />
          );
        default:
          return <></>;
      }
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
